import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import View from './View';
import { SectionHeadingSchema } from './schema';

const Edit = (props) => {
  const { data, block, onChangeBlock, selected } = props;
  const intl = useIntl();
  const schema = SectionHeadingSchema({ intl });

  return (
    <>
      <div className="section-heading-preview">
        <View data={data} />
      </div>
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) => {
            onChangeBlock(block, { ...data, [id]: value });
          }}
          formData={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

Edit.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  block: PropTypes.string.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
};

export default withBlockExtensions(Edit);
